const PHONE = '+56 9 9167 3285';
const WHATSAPP_NUMBER = '56991673285';
const EMAIL = 'Zavetransportes@gmail.com';
const INSTAGRAM_URL = 'https://www.instagram.com/zavetransportesanf/';

const WHATSAPP_MESSAGES = {
  es: `Hola, quiero cotizar un traslado.
Origen:
Destino:
Fecha:
Hora:
Cantidad de pasajeros:`,
  en: `Hello, I would like to get a quote for a transfer.
Origin:
Destination:
Date:
Time:
Number of passengers:`,
};

export function getWhatsAppUrl(lang = 'es') {
  const message = WHATSAPP_MESSAGES[lang] || WHATSAPP_MESSAGES.es;
  const text = encodeURIComponent(message);
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${text}`;
}

export function getTelUrl() {
  return `tel:${PHONE.replace(/\s/g, '')}`;
}

export { PHONE, EMAIL, WHATSAPP_NUMBER, INSTAGRAM_URL };
